import { useRef } from "react";
import { useMotionValue, useSpring, useTransform, useMotionTemplate } from "framer-motion";
import useMotionGuard from "./useMotionGuard";

/**
 * Tilt 3D + glossy highlight per card premium.
 * Attenuato a ±4° (dal ±8° iniziale) su richiesta: preferiamo sottile a vistoso.
 * Disattivato su touch e reduced-motion.
 */
export default function useTilt({ max = 4 } = {}) {
    const ref = useRef(null);
    const { disabled } = useMotionGuard();

    const px = useMotionValue(0.5);
    const py = useMotionValue(0.5);

    const rxRaw = useTransform(py, [0, 1], [max, -max]);
    const ryRaw = useTransform(px, [0, 1], [-max, max]);
    const rotateX = useSpring(rxRaw, { stiffness: 220, damping: 22, mass: 0.35 });
    const rotateY = useSpring(ryRaw, { stiffness: 220, damping: 22, mass: 0.35 });

    const hxPct = useTransform(px, [0, 1], [0, 100]);
    const hyPct = useTransform(py, [0, 1], [0, 100]);
    const shineBackground = useMotionTemplate`radial-gradient(circle at ${hxPct}% ${hyPct}%, rgba(229,255,0,0.14), transparent 55%)`;

    const onMouseMove = (e) => {
        if (disabled || !ref.current) return;
        const r = ref.current.getBoundingClientRect();
        px.set((e.clientX - r.left) / r.width);
        py.set((e.clientY - r.top) / r.height);
    };
    const onMouseLeave = () => {
        px.set(0.5);
        py.set(0.5);
    };

    return { ref, onMouseMove, onMouseLeave, rotateX, rotateY, shineBackground, disabled };
}
